import {Platforms, PlatformsName, PlatformState} from "../types/table-data.types";

const createPlatformState = (): PlatformState => ({
  isActionsColumnOpen: false,
  isStatsColumnOpen: false,
  isResultsColumnOpen: false,
});

export const defaultPlatforms: Platforms = {
  product: createPlatformState(),
  instagram: createPlatformState(),
  vk: createPlatformState(),
  youtube: createPlatformState(),
  dzen: createPlatformState(),
  ok: createPlatformState(),
  tiktok: createPlatformState(),
  telegram: createPlatformState(),
  max: createPlatformState()
};

export const platformNames: PlatformsName[] = [
  {type: 'instagram', title: 'Instagram'},
  {type: 'vk', title: 'Vkontakte'},
  {type: 'youtube', title: 'Youtube'},
  {type: 'dzen', title: 'Dzen'},
  {type: 'ok', title: 'Ok'},
  {type: 'tiktok', title: 'TikTok'},
  {type: 'telegram', title: 'Telegram'},
  {type: 'max', title: 'Max'}
]

export const defaultPlatformPlans = {
  'plan': 0,
  'integrationsPlan': 0,
  'telegramPlan': 0,
  'telegramIntegrationsPlan': 0,
  'instagramPlan': 0,
  'instagramIntegrationsPlan': 0,
  'vkPlan': 0,
  'vkIntegrationsPlan': 0,
  'youtubePlan': 0,
  'youtubeIntegrationsPlan': 0,
  'dzenPlan': 0,
  'dzenIntegrationsPlan': 0,
  'okPlan': 0,
  'okIntegrationsPlan': 0,
  'tiktokPlan': 0,
  'tiktokIntegrationsPlan': 0,
  'maxPlan': 0,
  'maxIntegrationsPlan': 0
}
